const name = 'CompProduto';

import { helpers, required, requiredIf } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import ComponenteController from "@/shared/controllers/componente/componenteController";
import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import gDataTable from "@/components/g-data-table/g-data-table.vue";
import OrcamentoComponenteController from "@/shared/controllers/orcamentoComponente/orcamentoComponenteController";
import ProdutoController from "@/shared/controllers/produto/produtoController"
import ClienteController from "@/shared/controllers/cliente/clienteController";
import UnidadeController  from '@/shared/controllers/unidade/unidadeController'
import ComponenteViewModel from "@/shared/view-models/ComponenteViewModel";
import Tools from "@/shared/services/tools";
import EmpresaController from "@/shared/controllers/empresa/empresaController";
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";
// import Tools from "@/shared/services/tools";

export default {
  name,

  components: {
    'g-button':gButton,
    'g-data-table': gDataTable,
    'g-card':gCard,
   },
  props: { },
  mounted() {
    OrcamentoController.VerificaSeOrcamentoTemQuantidade(this.$route.params.id).requisicao
    .then((response) => {
      /*eslint-disable*/
      if(response.data.data == false){
        this.$toast.add({severity:'error', detail:'Erro ao Salvar Quantidade. Por favor tente novamente.', life: 5000})
        this.$router.push(`/produto-novo/${this.$route.params.id}/info-basicas`)
      }
    })

    EmpresaController.getAllEmpresa().requisicao
    .then((Response) => {
      this.UnidadeArrayComponenteTipo = Response.data.data
      this.UnidadeArray = Response.data.data  
    })
    this.CapaExternaArray         = ComponenteController.getEnumDescricaoCapaExterna().CapaExternaArray
    this.CapaInternaArray         = ComponenteController.getEnumDescricaoCapaInterna().CapaInternaArray
    this.CorFrenteAcabamentoArray = ComponenteController.getEnumDescricaoAcabamentoFrente().CorFrenteAcabamentoArray
    this.CorFrenteArray           = ComponenteController.getEnumDescricaoCoresFrente().CorFrenteArray
    this.CorVersoAcabamentoArray  = ComponenteController.getEnumDescricaoAcabamentoVerso().CorVersoAcabamentoArray
    this.CorVersoArray            = ComponenteController.getEnumDescricaoCoresVerso().CorVersoArray
    this.MaterialArray            = ComponenteController.getEnumDescricaoMaterial().MaterialArray
    this.SistemaArray             = OrcamentoComponenteController.getEnumDescricaoSistema().SistemaArray
    this.MedidaConformeArray      = ComponenteController.getEnumEnumDescricaoMedida().MedidaConformeArray
    this.OndaArray                = ComponenteController.getEnumDescricaoOnda().OndaArray
    this.PapelOndaArray           = ComponenteController.getEnumDescricaoCapaPapelOnda().PapelOndaArray
    this.TipoComponenteArray      = ComponenteController.getEnumTipoComponente().TipoComponenteArray
    this.ProdutoSistemaOpcoes     = ProdutoController.GetProdutoByTableSistema().ProdutoOpcoesProdutoNumero
    this.getClienteId()
    this.getProdutoIdByOrcamentoId()
    this.getComponetesByOrcamentoId()
    this.novoComponente.DescricaoMaterail = 3
    this.getOrcamentobyId()
    this.ImagemEmpresa()
  },
  setup(){
    return {
      v$: useVuelidate()
    }
  },
  validations() {
    return{
      numeroPrototipoComponenteTipo: {required: helpers.withMessage('O campo de N° Protótipo do Conforme necessita de um valor', requiredIf(this.novoComponente.DescricaoMedidas == 1))},
      numeroPrototipoMaterial: {required: helpers.withMessage('O campo de N° Protótipo do Material necessita de um valor', requiredIf(this.novoComponente.DescricaoMaterial == 7))},
      numeroPrototipoSistema: {required: helpers.withMessage('O campo de N° Protótipo do Sistema necessita de um valor', requiredIf(this.SistemaSelecionado == 3 ))},
      UnidadeSelecionadaComponenteTipo :{required: helpers.withMessage('O campo de Unidade do Conforme necessita de um valor', requiredIf(this.novoComponente.DescricaoMedidas == 0 ))},
      ProdutoMaterialId : {required: helpers.withMessage('O campo de Produto do Conforme necessita de um valor', requiredIf(this.novoComponente.DescricaoMedidas == 0 ))},
      SistemaSelecionado        : {required: helpers.withMessage('O campo de Sistema necessita de um valor', required)},
      UnidadeSelecionadaSistema :{required: helpers.withMessage('O campo de Unidade do Sistema necessita de um valor', requiredIf(this.SistemaSelecionado == 2))},
      ProdutoSistemaId : {required: helpers.withMessage('O campo de Produto do Sistema necessita de um valor', requiredIf(this.SistemaSelecionado == 2 && !(this.novoComponente.ProdutoSistemaId)))},
      SistemaId : {required: helpers.withMessage('O campo de Produto do Sistema necessita de um valor', requiredIf(this.SistemaSelecionado == 0 && this.SistemaSelecionado == 0  &&(this.SistemaId == null || this.SistemaId == undefined) ))},

      novoComponente:{
          ComponenteTipo            : {required: helpers.withMessage('O campo de Tipo Componente necessita de um valor', required)},
          DescricaoMaterial         : {required: helpers.withMessage('O campo de Material necessita de um valor', required)},
          DescricaoPapelOnda        : {required: helpers.withMessage('O campo de Papel Onda necessita de um valor', requiredIf(!this.ObrigatoriedadePapelDeOndaComp))},
          NumeroGramaturaPapelOnda  : {required: helpers.withMessage('O campo de Número Gramatura Papel Onda necessita de um valor', requiredIf(!this.ObrigatoriedadePapelDeOndaComp))},
          NumeroGramaturaCapaExterna: {required: helpers.withMessage('O campo de Número Gramatura Capa Externa necessita de um valor', requiredIf(!this.ObrigatoriedadeGramaturaCapaExternaComp))},
          DescricaoCapaExterna      : {required: helpers.withMessage('O campo de Capa Externa necessita de um valor', requiredIf(!this.ObrigatoriedadeDescricaoCapaExternaComp))},
          NumeroAlturaTampa         : {required: helpers.withMessage('O campo de Altura Tampa necessita de um valor', requiredIf(!this.ObrigatoriedadeAlturaTampaComp && this.novoComponente.DescricaoMedidas == null))},
          DescricaoMedidas          : {required: helpers.withMessage('O campo de Conforme necessita de um valor', requiredIf( this.novoComponente.NumeroAltura == null && this.novoComponente.NumeroComprimento == null && this.novoComponente.NumeroLargura == null ))},
          DescricaoCoresVerso       : {required: helpers.withMessage('O campo de Cor Verso de um valor', required)},
          DescricaoCoresFrente      : {required: helpers.withMessage('O campo de Cor Frente de um valor', required)},
          DescricaoAcabamentoVerso  : {required: helpers.withMessage('O campo de Acabamento Verso necessita de um valor', required)},
          DescricaoAcabamentoFrente : {required: helpers.withMessage('O campo de Acabamento Frente necessita de um valor', required)},
          DescricaoCapaInterna      : {required: helpers.withMessage('O campo de Capa Interna de um valor', requiredIf(!this.ObrigatoriedadeCapaInternaComp))},
          NumeroGramaturaCapaInterna: {required: helpers.withMessage('O campo de Número Gramatura Capa Interna necessita de um valor', requiredIf(!this.ObrigatoriedadeCapaInternaComp))},
          NumeroAltura              : {required: helpers.withMessage('O campo de Altura necessita de um valor', requiredIf(this.novoComponente.DescricaoMedidas == null))},
          NumeroComprimento         : {required: helpers.withMessage('O campo de Comprimento necessita de um valor', requiredIf(this.novoComponente.DescricaoMedidas == null))},
          NumeroLargura             : {required: helpers.withMessage('O campo de Largura necessita de um valor', requiredIf(this.novoComponente.DescricaoMedidas == null))},

      }
    }
   },
  updated () {

  },
  data () {
    return {
      popupCancelaOrc:false,
      imagemEmpresa: '',
      timer: null,
      ProdutoOpcoesProdutoNumero: [],
      ProdutoSistemaOpcoes: [],
      index: 0,
      copiaOrcamentoQuantidade: false,
      reorcamento: false,
      CapaExternaArray              : [],
      CapaInternaArray              : [],
      ClienteId                     : null,
      codigo                        : null,
      ComponenteId                  : null,
      comprimento                   : null,
      CorFrenteAcabamentoArray      : [],
      CorFrenteArray                : [],
      CorVersoAcabamentoArray       : [],
      CorVersoArray                 : [],
      desativarGrid                 : false,
      displayModalConfirmacao       : false,
      EhAdicionavel                 : true,
      ehAmostraEspecificacaoTecnica : false,
      ehEdicao                      : false,
      ehEmpastado                   : false,
      ehFaceSimples                 : false,
      EmpresaId                     : null,
      MaterialArray                 : [],
      MaterialSelecionado           : null,
      MedidaConformeArray           : [],
      novoComponente: new ComponenteViewModel(),
      OndaArray                     : [],
      orcamentoComponenteId         : null,
      PapelOndaArray                : [],
      popup                         : false,
      popupadicionarcomponente      : false,
      popupadicionarreferencia      : false,
      produto                       : null,
      ProdutoArray                  : [],
      SistemaArray                  : [],
      SistemaSelecionado            : null,
      textoVazio                    : 'Nenhum componente adicionado',
      TipoComponenteArray           : [],
      UnidadeArray                  : [],
      colunasDaTabela: [
        {field: "NumeroComponente", header: "Número"},
        {field:'ComponenteTipoTexto', header:'Tipo Componente'},
        {field:'ColunaMedidas', header:'Medidas'},
        {field:'DescricaoCoresFrenteTexto',header:'Cores Frente'},
        {field:'DescricaoCoresVersoTexto',header:'Cores Verso'},
        {field:'DescricaoAcabamentoFrenteTexto',header:'Acabamento Frente'},
        {field:'DescricaoAcabamentoVersoTexto',header:'Acabamento Verso'},
        {field:'DescricaoMaterialTexto',header:'Material'},
        {field:'DescricaoCapaExternaTexto',header:'Capa Externa'},
        {field:'NumeroGramaturaCapaExterna',header:'Gramatura'},
        {field:'DescricaoPapelOndaTexto',header:'Papel Onda'},
        {field:'NumeroGramaturaPapelOnda',header:'Papel Onda'},
        {field:'DescricaoCapaInternaTexto',header:'Capa Interna'},
        {field:'NumeroGramaturaCapaInterna',header:'Gramatura'},
        {field:'DescricaoOndaTexto',header:'Onda'},
        {field:'SistemaTexto',header:'Sistema', width: '9%'},


    ], //colunas da tabela

      informacao : [], //conteudo da tabela, será puxado do back
      Filtro: {
          'codigoSistema'                 : {value: null, matchMode: this.filtros.CONTAINS},
          'ColunaMedidas'                 : {value: null, matchMode: this.filtros.CONTAINS},
          'descricaoAcabamentoFrenteTexto': {value: null, matchMode: this.filtros.CONTAINS},
          'descricaoAcabamentoVersoTexto' : {value: null, matchMode: this.filtros.CONTAINS},
          'descricaoCapaExternaTexto'     : {value: null, matchMode: this.filtros.CONTAINS},
          'descricaoCapaInternaTexto'     : {value: null, matchMode: this.filtros.CONTAINS},
          'descricaoCoresFrenteTexto'     : {value: null, matchMode: this.filtros.CONTAINS},
          'descricaoCoresVersoTexto'      : {value: null, matchMode: this.filtros.CONTAINS},
          'descricaoMaterialTexto'        : {value: null, matchMode: this.filtros.CONTAINS},
          'descricaoMedidasTexto'         : {value: null, matchMode: this.filtros.CONTAINS},
          'descricaoOndaTexto'            : {value: null, matchMode: this.filtros.CONTAINS},
          'descricaoPapelOndaTexto'       : {value: null, matchMode: this.filtros.CONTAINS},
          'global'                        : {value: null, matchMode: this.filtros.CONTAINS},   //permite buscar por colunas específicas
          'numeroAlturaTampa'             : {value: null, matchMode: this.filtros.CONTAINS},
          'numeroGramaturaCapaExterna'    : {value: null, matchMode: this.filtros.CONTAINS},
          'numeroGramaturaCapaInterna'    : {value: null, matchMode: this.filtros.CONTAINS},
          'numeroGramaturaPapelOnda'      : {value: null, matchMode: this.filtros.CONTAINS},
        },

        campPrototipoComponenteTipo:false,
        numeroPrototipoComponenteTipo: null,
        campConformeProdutoComponenteTipo: false,
        NomeProdutoComponenteTipo: null,
        UnidadeSelecionadaComponenteTipo: null,

        numeroPrototipoMaterial: null,

        UnidadeSelecionadaSistema: null,
        NomeProdutoSistema: null,
        campConformeProdutoSistema: false,
        campPrototipoSistema: false,
        numeroPrototipoSistema: null,

        campConformeTabelaSistema: false,
        SistemaId: null,

        UnidadeArrayComponenteTipo: null,

        ConformeTabelaSistemaOpcoes: [],


        ProdutoSistemaId: null,
        ProdutoMaterialId: null,
        ProdutoOpcoes: [],
        temAmostra: false,
        ObrigatoriedadeAlturaTampa: true,
        ObrigatoriedadePapelDeOnda: true,
        ObrigatoriedadeExterna: true,
        ObrigatoriedadeGramaturaCapaExterna: true,
        indexAux: -1
       }
  },
  methods: {

    GetUnidadeByProdutoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Componente/GetUnidadeByProdutoId/${this.produtoIdSelecionado}`,
      }).then((res) => {
        // this.getComponetesByOrcamentoId()
        this.UnidadeSelecionadaSistema = res.data.data;

      })
    },

    cancelaOrcamento() {
      this.$isLoading(true)
      OrcamentoController.DeleteOrcamento(this.$route.params.id).requisicao
      .then(() =>
        this.popupCancelaOrc = false,
        this.$toast.add({severity:'success', detail:'Orçamento Excluido com Sucesso!', life: 5000}),
        setTimeout(() => {
          this.$isLoading(false),
          this.$router.push('/produto-novo-inicio');
        },2000))
    },
    fechaPopupCancelar() {
      this.popupCancelaOrc = false;
    },
    abrePopupCancelarOrcamento(){
      this.popupCancelaOrc = true;
    },
    ImagemEmpresa(){
      OrcamentoController.GetNomeEmpresaByOrcamentoId(this.$route.params.id).requisicao
      .then((response) => {
        this.NomeEmpresa=response.data.message

        const nomeEmpresa = () => {
          if(this.NomeEmpresa.includes('SUPREMA')) return 'SUPREMA';
          if(this.NomeEmpresa.includes('NORDESTE')) return 'NORDESTE';
          return 'JAUENSE'
        }

        const urlBase = window.location.host
        this.imagemEmpresa =  `http://${urlBase}/repositorio/${nomeEmpresa()}/LOGOTIPO.png`;
      })
    },
    step5 () {
      if(this.informacao.length == 0 && this.ehAmostraEspecificacaoTecnica == false)
      {
        this.$toast.add({ severity: 'error', summary: 'Aviso', detail: 'É preciso ter selecionado "Todas as especificações técnicas seguirão conforme amostra" para avançar sem componentes', life: 8000 });
      }
      else {
        this.postOrcamentoComponente()
        this.informacao=[]
        // this.$router.push(`/produto-novo/${this.$route.params.id}/caracteristicas-produto`)
      }
    },
    voltarstep3(){
      this.$router.push(`/produto-novo/${this.$route.params.id}/info-basicas`)
    },
    getOrcamentobyId(){
      let OrcamentoId = this.$route.params.id
      let retorno = this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Orcamento/GetOrcamentoById/Get/${OrcamentoId}`,
     })
     .then((response) => {
      this.ehAmostraEspecificacaoTecnica = response.data.data.amostraEspecificacaoTecnica
      this.reorcamento = response.data.data.reorcamento;
      this.copiaOrcamentoQuantidade = response.data.data.copiaOrcamentoQuantidade;
      this.temAmostra = response.data.data.amostra

      //conferindo no back se a informação salva é que o segundo checkbox (conforme a amostra) foi selecionado
      if(this.ehAmostraEspecificacaoTecnica === true){
        this.EhAdicionavel = false //grid não permitindo adições
        this.textoVazio = "Seguirá as especificações técnicas conforme amostra" //alterando texto vazio do grid
      }

      if(this.reorcamento === true){
        this.EhAdicionavel = false //grid não permitindo adições
      }

      if(this.copiaOrcamentoQuantidade === true){
        this.EhAdicionavel = false //grid não permitindo adições
      }
      })
      return retorno

    },
    fecharDialogConfirmacao(){
      this.displayModalConfirmacao = false
      this.desativarGrid = true
    },
    adicionar(){
      // abrir popup de adicionar componente
      this.popup = true

    },
    AdicionarComponente(){
      this.novoComponente = new ComponenteViewModel()
      this.popup                          = false
      this.popupadicionarcomponente       = true
      this.ehEdicao                       = false
      this.SistemaSelecionado             = null
      this.UnidadeSelecionadaSistema      = null
      this.ProdutoSistemaId               = null
      this.SistemaId                      = null
    },
    limparCamposMedidas(){
      this.altura=0,
      this.alturaTampa=0,
      this.comprimento=0,
      this.largura=0

      this.novoComponente.NumeroAltura = null
      this.novoComponente.NumeroComprimento = null
      this.novoComponente.NumeroLargura = null
      this.novoComponente.NumeroAlturaTampa = null
      // this.novoComponente.DescricaoMedidas == 0 ? this.campConformeProdutoComponenteTipo = true : this.campConformeProdutoComponenteTipo = false
      // this.novoComponente.DescricaoMedidas == 1 ? this.campPrototipoComponenteTipo = true : this.campPrototipoComponenteTipo = false


      if (this.novoComponente.DescricaoMedidas == 5)
      {
        if(this.novoComponente.ComponenteTipo != 0)
        {
          this.$toast.add({ severity: 'error', summary: 'Aviso', detail: 'Item Conforme fundo exclusivo para o componente Tampa', life: 4000 });
          this.novoComponente.DescricaoMedidas = null
        }
      }
      else if(this.novoComponente.DescricaoMedidas == 0)
      {
        EmpresaController.getAllEmpresa().requisicao
        .then((Response) => {
          this.UnidadeArrayComponenteTipo = Response.data.data
        })
      }
      else if(this.novoComponente.DescricaoMedidas == 4 && this.temAmostra == false )
      {
        this.$toast.add({ severity: 'error', summary: 'Aviso', detail: 'Para medida Conforme Amostra, é necessário marcar o item Acompanha amostra na tela anterior!', life: 7000 });
        this.novoComponente.DescricaoMedidas = null
      }


    },

    limparConforme(){
      if(this.novoComponente.NumeroLargura != null || this.novoComponente.NumeroAltura != null || this.novoComponente.NumeroComprimento != null || this.novoComponente.NumeroAlturaTampa != null)
      this.novoComponente.DescricaoMedidas = null
    },

    VerificacaoSistema(){
      // this.ProdutoSistemaOpcoes = []

      this.SistemaId = null;
      this.ProdutoSistemaId = null;
      this.UnidadeSelecionadaSistema = null;
      this.numeroPrototipoSistema = null;

      if(this.SistemaSelecionado != null && this.novoComponente.ComponenteTipo == null)
      {
        this.$toast.add({ severity: 'error', summary: 'Aviso', detail: 'Selecione um componente', life: 7000 });
        this.SistemaSelecionado = null
      }

      if(this.SistemaSelecionado == 1 && this.temAmostra == false )
      {
        this.$toast.add({ severity: 'error', summary: 'Aviso', detail: 'Para sistema Conforme Amostra, é necessário marcar o item Acompanha amostra na tela anterior!', life: 7000 });
        this.SistemaSelecionado = null
      }
      // this.SistemaSelecionado == 2 ? this.campConformeProdutoSistema = true : this.campConformeProdutoSistema = false
      // this.SistemaSelecionado == 3 ? this.campPrototipoSistema = true : this.campPrototipoSistema = false
      this.SistemaSelecionado == 0 ? this.campConformeTabelaSistema = true : this.campConformeTabelaSistema = false


      if(this.SistemaSelecionado == 0)
      {
        this.getUnidadeByClienteId()
        this.limpaCamposSistema()
      }
      else if(this.SistemaSelecionado == 2 )
      {
        EmpresaController.getAllEmpresa().requisicao
          .then((Response) => {
            this.UnidadeArray = Response.data.data
          })

          this.limpaCamposSistema()
      } else if (this.SistemaSelecionado != 2 && this.SistemaSelecionado != 0) {
        this.limpaCamposSistema()
      }
    },

    getUnidadeByClienteId(){
      UnidadeController.getUnicaUnidadeByClienteId(this.ClienteId).requisicao
        .then((Response) => {
          this.UnidadeSelecionadaSistema = Response.data.data


          EmpresaController.getAllEmpresa().requisicao
          .then((Response) => {
            this.UnidadeArray = Response.data.data
          })
        })
    },

    verificaComponenteTipo(){

      !this.novoComponente.ComponenteTipo == 0 || !this.novoComponente.ComponenteTipo == 3 || !this.novoComponente.ComponenteTipo == 4 || !this.novoComponente.ComponenteTipo == 5 ? this.ObrigatoriedadeAlturaTampa = true : this.ObrigatoriedadeAlturaTampa=false
        if(this.novoComponente.ComponenteTipo != 0)
        {
          if(this.novoComponente.DescricaoMedidas == 5)
          {
            this.novoComponente.DescricaoMedidas = null
          }
        }
        else if(this.novoComponente.ComponenteTipo == null)
        {
          this.SistemaSelecionado == null
        }
        else if(this.novoComponente.ComponenteTipo == 0 || this.novoComponente.ComponenteTipo == 3 || this.novoComponente.ComponenteTipo == 4 || this.novoComponente.ComponenteTipo == 5)
        {
          this.novoComponente.NumeroAlturaTampa = null
        }

    },
    desativarCamposMateriais(){

      this.ObrigatoriedadeExterna = !this.novoComponente.DescricaoMaterial == 2 || !this.novoComponente.DescricaoMaterial == 4 || !this.novoComponente.DescricaoMaterial == 5 || !this.novoComponente.DescricaoMaterial == 6 || !this.novoComponente.DescricaoMaterial == 7 || !this.novoComponente.DescricaoMaterial == 8

      this.novoComponente.DescricaoOnda=undefined
      this.novoComponente.DescricaoCapaExterna=undefined
      this.novoComponente.NumeroGramaturaCapaExterna=undefined
      this.novoComponente.DescricaoPapelOnda = undefined
      this.novoComponente.NumeroGramaturaPapelOnda = undefined
      this.novoComponente.DescricaoCapaInterna=undefined
      this.novoComponente.NumeroGramaturaCapaInterna = undefined
      this.numeroPrototipoMaterial = null
      
      


      if(this.novoComponente.DescricaoMaterial == 8){
        this.novoComponente.DescricaoCapaExterna =  9
      }

      else if(this.novoComponente.DescricaoMaterial == 4 && this.temAmostra == false )
      {
        this.$toast.add({ severity: 'error', summary: 'Aviso', detail: 'Para material Conforme Amostra, é necessário marcar o item Acompanha amostra na tela anterior!', life: 7000 });
        this.novoComponente.DescricaoMaterial = null
      }



    },
    AdicionarReferencia(){
      this.popup = false
      this.popupadicionarreferencia = true
    },
    adicionandocomponente(){ //adicionará na tabela o componente
      if(this.v$.$invalid){
        this.v$.$silentErrors.forEach(error=>{
          this.$toast.add({severity:'error', summary: 'ERRO', detail:error.$message, life: 5000})
        })}else{

          this.popupadicionarcomponente=false

          if(this.ehEdicao){
            this.EditarOrcamentoComponenteNoGrid()
            this.ehEdicao=false;

          }else{
            this.AdicionarOrcamentoComponenteAoGrid()
          }
        }
    },
    cancelandoadicionarcomponente(){
      /* eslint-disable */
      this.popupadicionarcomponente=false
    },
    adicionandoreferencia(){
      this.popupadicionarreferencia=false
      this.popupadicionarcomponente=false
      this.getComponentesByProdutoIdSelecionado()
    },
    cancelandoadicionarreferencia(){
      this.popupadicionarreferencia=false
      this.popupadicionarcomponente=false
    },
    editar(data, i){
      this.indexAux = i  
      this.novoComponente = new ComponenteViewModel()
      Tools.objectCustomAssign(this.novoComponente, data)
      this.produtoIdSelecionado = data.ProdutoId
      this.SistemaSelecionado = this.novoComponente.DescricaoSistema
      this.ProdutoSistemaId = data == null ? this.novoComponente.ProdutoSistemaId : data.ProdutoSistemaId
      this.ProdutoMaterialId = this.novoComponente.ProdutoMaterialId
      this.numeroPrototipoSistema = this.novoComponente.NumeroPrototipoSistema
      this.numeroPrototipoMaterial = this.novoComponente.NumeroPrototipoMaterial
      this.numeroPrototipoComponenteTipo = this.novoComponente.NumeroPrototipoComponenteTipo
      this.SistemaId = this.novoComponente.SistemaId
      
      this.UnidadeSelecionadaSistema = this.novoComponente.SistemaUnidadeId;
      this.UnidadeSelecionadaComponenteTipo = this.novoComponente.ConformeUnidadeId;

      if(this.SistemaSelecionado == 0 && this.SistemaId==null)
      this.getUnidadeByClienteId()

      
      if(this.SistemaSelecionado == 0 && this.SistemaId!=null)
      this.GetUnidadeByProdutoId()


      if(this.novoComponente.ProdutoMaterialLista){
        this.ProdutoOpcoes = this.novoComponente.ProdutoMaterialLista;
      }
      if(this.ProdutoSistemaId != null){
        this.getProdutoId(this.ProdutoSistemaId)
      }
      if(this.novoComponente.ProdutoSitemaLista){
        this.ProdutoOpcoesProdutoNumero = this.novoComponente.ProdutoSitemaLista;
      }

      this.popupadicionarcomponente = true
      this.ehEdicao = true;
    },
    excluir(data){
       if(!data.OrcamentoComponenteId){
       //Remover se não adicionou no back
           this.removerDoGrid(data.TempId,'TempId')

         }else{
      //    remover orcaento componente caso já esteja adicionado
          this.postExcluirOrcamentoComponente(data.OrcamentoComponenteId)
          this.removerDoGrid(data.OrcamentoComponenteId ,'OrcamentoComponenteId')
        }

    },

    limparProdutoMaterial(){
      this.ProdutoMaterialId = ''
      this.ProdutoOpcoes = []
    },

    limparProdutoSistema(){
      this.ProdutoSistemaId = null
      this.ProdutoOpcoesProdutoNumero  = []
      this.ProdutoSistemaOpcoes = []
    },

    removerDoGrid(id,campo){
      this.informacao = this.informacao.filter((obj)=> {
        return !(obj[campo] === id)
      })
    },
    getProdutoId (id) {
      ProdutoController.GetPorId(id).requisicao
        .then((Response) => {
          this.ProdutoOpcoesProdutoNumero = Response.data.data
        })
    },
    postExcluirOrcamentoComponente(id){
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `OrcamentoComponente/ExcluirOrcamentoComponente`,
        data:{
          Id:id
        }
      })
    },
    getClienteId(){
      this.$isLoading(true)
      ClienteController.getClienteByOrcamento(this.$route.params.id).requisicao
      .then((response) => {
        this.ClienteId=response.data.data.id
      }).finally(()=> {
        this.$isLoading(false)
      })
    },

    postOrcamentoComponente(){
      this.$refs.botaoContinuar.isBusy()
      this.axios({
        method: 'post',
          url: process.env.VUE_APP_WEB_API + 'OrcamentoComponente/post',
          data:{
            Id : this.$route.params.id, // orcamentoViewModel
            EmpresaId : this.UnidadeSelecionada ? this.UnidadeSelecionada : this.getUnidadeByClienteId(), // orcamentoViewModel
            DescricaoSistema: this.SistemaSelecionado ?  this.SistemaSelecionado : 2, // orcamentoViewModel
            ComponenteData:this.informacao, // orcamentoViewModel > componenteViewModel
          }
        })
          .then(() => {
            this.$router.push(`/produto-novo/${this.$route.params.id}/caracteristicas-produto`)
            this.getComponetesByOrcamentoId()
          }).finally(this.$refs.botaoContinuar.isBusy)
    },
    AdicionarOrcamentoComponenteAoGrid(){
      this.novoComponente.DescricaoSistema = this.SistemaSelecionado;
      this.novoComponente.ProdutoSistemaId = this.ProdutoSistemaId;
      this.novoComponente.SistemaId = this.SistemaId;
      this.novoComponente.ProdutoMaterialId = this.ProdutoMaterialId;
      this.novoComponente.NumeroPrototipoSistema = this.numeroPrototipoSistema;
      this.novoComponente.NumeroPrototipoMaterial = this.numeroPrototipoMaterial;
      this.novoComponente.NumeroPrototipoComponenteTipo = this.numeroPrototipoComponenteTipo;
      this.novoComponente.SistemaUnidadeId = this.UnidadeSelecionadaSistema;
      this.novoComponente.ConformeUnidadeId = this.UnidadeSelecionadaComponenteTipo;
      this.novoComponente.SistemaTexto = this.SistemaArray.filter(e => e.value === this.SistemaSelecionado)[0].text;
      this.index++;
      this.novoComponente.NumeroComponente = this.index;
      this.informacao.push(this.novoComponente);
      this.novoComponente = new ComponenteViewModel();
    },
    EditarOrcamentoComponenteNoGrid(){
      this.novoComponente.DescricaoSistema = this.SistemaSelecionado;
      this.novoComponente.ProdutoSistemaId = this.ProdutoSistemaId;
      this.novoComponente.ProdutoMaterialId = this.ProdutoMaterialId;
      this.novoComponente.NumeroPrototipoSistema = this.numeroPrototipoSistema;
      this.novoComponente.NumeroPrototipoMaterial = this.numeroPrototipoMaterial;
      this.novoComponente.NumeroPrototipoComponenteTipo = this.numeroPrototipoComponenteTipo;
      this.novoComponente.SistemaUnidadeId = this.UnidadeSelecionadaSistema;
      this.novoComponente.ConformeUnidadeId = this.UnidadeSelecionadaComponenteTipo;
      this.novoComponente.SistemaId = this.SistemaId;

      if (this.novoComponente.DescricaoSistema == 0){
        this.novoComponente.CodigoSistema = this.ProdutoSistemaOpcoes.find((e) => e.id == this.SistemaId).codigoSistema;
      }
      this.novoComponente.SistemaTexto = this.SistemaArray.filter(e => e.value === this.SistemaSelecionado)[0].text;

      this.informacao = this.informacao.map(obj => {
        if(obj.TempId === this.novoComponente.TempId){
          obj = this.novoComponente
        }
        return obj
      })
    },
    getComponetesByOrcamentoId(){
      ComponenteController.getComponentesByOrcamentoId(this.$route.params.id).requisicao
      .then((Response) => {
        Response.data.data.forEach((obj)=>{
              obj = this.trocarChaveObjetoParaMaiusculo(obj)
              this.informacao.push(obj)
            })
             this.informacao.forEach((r)=>{
              this.index = r.NumeroComponente;
                if(!r.NumeroComprimento && !r.NumeroLargura && !r.NumeroAltura && !r.NumeroAlturaTampa)
                  r.ColunaMedidas = r.DescricaoMedidasTexto;
                else
                  r.ColunaMedidas = `${r.NumeroAltura} x ${r.NumeroComprimento} x ${r.NumeroLargura} x ${r.NumeroAlturaTampa}`
             })
           })
    },
    trocarChaveObjetoParaMaiusculo(obj){
      Object.keys(obj).forEach(chave => {
        let chaveNova = ()=>{
          return `${chave[0].toUpperCase() + chave.slice(1,chave.length)}`
        }
        obj[chaveNova()] = obj[chave]
        delete obj[chave]
       })
       return obj
    },
    getProdutoIdByOrcamentoId(){
      this.ProdutoId = ProdutoController.getProdutoByOrcamentoId(this.$route.params.id).ProdutoId
    },
    getComponentesByProdutoIdSelecionado(){
      ComponenteController.getComponentesByProdutoId(this.novoComponente.ProdutoSistemaId).requisicao
      .then((Response)=>{
        Response.data.data.forEach((obj,index)=>{
            obj = this.trocarChaveObjetoParaMaiusculo(obj)
            obj.id = null
            // obj.NumeroComponente = this.componenteIndex
            this.index++;
            obj.NumeroComponente = this.index;
            this.informacao.push(obj)
          })
          this.informacao.forEach((r)=>{
            r.ColunaMedidas = `${r.NumeroComprimento} x ${r.NumeroLargura} x ${r.NumeroAltura} x ${r.NumeroAlturaTampa}`
            r.CodigoSistema = `${r.CodigoSistema}`
          })
        })
    },

    buscarProdutosConformeProduto(pesquisa){
      window.clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.ProdutoOpcoes = ProdutoController.getProdutoDropDown(this.$route.params.id, true, false, true, pesquisa, this.UnidadeSelecionadaComponenteTipo).ProdutoArray;
      }, 1000);
    },

    buscarProdutosProdutoNumero(pesquisa){
      window.clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.ProdutoOpcoesProdutoNumero = ProdutoController.getProdutoDropDown(this.$route.params.id, true, true, true, pesquisa, this.UnidadeSelecionadaSistema).ProdutoArray;
      }, 1000);
    },

    GetProdutoByTableSistema(){
      window.clearTimeout(this.timer)
      this.timer = setTimeout(() => {
          ProdutoController.GetProdutoByTableSistema().requisicao
          .then((resp) => {
            this.ProdutoSistemaOpcoes = resp.data.data;
          })
      }, 1000);
    },

    procurarproduto(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ProdutoArray = ProdutoController.getProdutoDropDown(this.$route.params.id, false, false, true, event).ProdutoArray
      }, 1000);
    },
    procurarSistema(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ConformeTabelaSistemaOpcoes = ProdutoController.GetSistemaByFiltro(this.novoComponente.ComponenteTipo, event).SistemaArray
      }, 1000);
    },
    procurarProdutoOpcoes(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ProdutoOpcoes = ProdutoController.GetProdutoByUsuarioIdEmpresaId(event, this.$route.params.id, this.UnidadeSelecionadaSistema).ProdutoArray
      }, 1000);
    },
    procurarProdutoOpcoesMaterial(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ProdutoOpcoes = ProdutoController.GetProdutoByUsuarioIdEmpresaId(event, this.$route.params.id, this.UnidadeSelecionadaComponenteTipo).ProdutoArray
      }, 1000);
    },
    verificaMedidaPreenchida(medida){
      return (medida || medida === '0,00' || medida === '0.00')
    },
    limpaProduto() {
      this.ProdutoSistemaId = null;
    },
    limpaSistema(){
      this.SistemaId = null;
    },
    limpaCamposSistema(){

      if (this.SistemaSelecionado == 0){
        this.ProdutoSistemaId = null;
        return
      }
      if (this.SistemaSelecionado == 2){
        this.SistemaId = null;
        return
      } 
      
      if (this.SistemaSelecionado != 2 && this.SistemaSelecionado != 0 ) {
        this.ProdutoSistemaId = null;
        this.SistemaId = null
      }
    },
    getCodigoSistema(sistemaId) {

      // this.informacao[this.indexAux].CodigoSistema = sistemaId

      let codigoSistema = this.ProdutoSistemaOpcoes.find((e) => e.id == sistemaId).codigoSistema;
            
      this.informacao[this.indexAux].CodigoSistema = codigoSistema

      // this.informacao.forEach((r)=>{
      //   r.CodigoSistema = codigoSistema
      // })

    },
  },
  computed: {
    componenteIndex(){
      let retorno = this.index;
      this.index++;
      return retorno;
    },

    ObrigatoriedadeConforme(){
      const conformeObrigatorio =
           !this.verificaMedidaPreenchida(this.novoComponente.NumeroAltura)
        && !this.verificaMedidaPreenchida(this.novoComponente.NumeroLargura)
        && !this.verificaMedidaPreenchida(this.novoComponente.NumeroComprimento)
        && !this.verificaMedidaPreenchida(this.novoComponente.NumeroAlturaTampa)
      return conformeObrigatorio;
    },

    ObrigatoriedadeCampos(){
      if(this.novoComponente.DescricaoMedidas === 0) return false;
      return !this.novoComponente.DescricaoMedidas;
    },

    ObrigatoriedadeGramaturaCapaExternaComp(){
      return this.novoComponente.DescricaoMaterial == 2 || this.novoComponente.DescricaoMaterial == 4 || this.novoComponente.DescricaoMaterial == 5 || this.novoComponente.DescricaoMaterial == 6 || this.novoComponente.DescricaoMaterial == 7
    },
    ObrigatoriedadeDescricaoCapaExternaComp(){
      return this.novoComponente.DescricaoMaterial == 2 || this.novoComponente.DescricaoMaterial == 4 || this.novoComponente.DescricaoMaterial == 5 || this.novoComponente.DescricaoMaterial == 6 || this.novoComponente.DescricaoMaterial == 7 || this.novoComponente.DescricaoMaterial == 8
    },
    ObrigatoriedadeAlturaTampaComp(){
      if(!this.ObrigatoriedadeCampos) return true;
      return (this.novoComponente.ComponenteTipo == 0 || this.novoComponente.ComponenteTipo == 3 || this.novoComponente.ComponenteTipo == 4 || this.novoComponente.ComponenteTipo == 5)
    },
    ObrigatoriedadeGramaturaCapaExternaComp(){
      return this.novoComponente.DescricaoMaterial == 2 || this.novoComponente.DescricaoMaterial == 4 || this.novoComponente.DescricaoMaterial == 5 || this.novoComponente.DescricaoMaterial == 6 || this.novoComponente.DescricaoMaterial == 7
    },
    ObrigatoriedadeDescricaoCapaExternaComp(){
      return this.novoComponente.DescricaoMaterial == 2 || this.novoComponente.DescricaoMaterial == 4 || this.novoComponente.DescricaoMaterial == 5 || this.novoComponente.DescricaoMaterial == 6 || this.novoComponente.DescricaoMaterial == 7 || this.novoComponente.DescricaoMaterial == 8
    },
    ObrigatoriedadePapelDeOndaComp(){
      return this.novoComponente.DescricaoMaterial == 1 || this.novoComponente.DescricaoMaterial == 3 || this.novoComponente.DescricaoMaterial == 4 || this.novoComponente.DescricaoMaterial == 5 || this.novoComponente.DescricaoMaterial == 6 || this.novoComponente.DescricaoMaterial == 7 || this.novoComponente.DescricaoMaterial == 8
    },
    ObrigatoriedadeCapaInternaComp(){
      return this.novoComponente.DescricaoMaterial == 1 || this.novoComponente.DescricaoMaterial == 4 || this.novoComponente.DescricaoMaterial == 5 || this.novoComponente.DescricaoMaterial == 6 || this.novoComponente.DescricaoMaterial == 7 || this.novoComponente.DescricaoMaterial == 8
    }
  },
}